
export const MODE = {
	ALL: "All",
	CINEMA: "Cinema",
	REAL: "Real"
};

export const GENDER = {
	ALL: "All",
	MALE: "Male",
	FEMALE: "Female"
};